// extracted by mini-css-extract-plugin
export default {"moduleStatus":"StatusLabel_moduleStatus__bbm6X","disabled":"StatusLabel_disabled__8jkcG","draft":"StatusLabel_draft__bMI-g","published":"StatusLabel_published__JtaRo"};